<template>
  <div id="navContainer">
    <div class="operations">
      <el-button type="primary" size="small" plain @click.stop="returnUpOneLevel">
        <i class="el-icon-return" style="margin-right:3px"></i>返回上一级
      </el-button>
    </div>
    <el-breadcrumb ref="breadDiv" separator="/">
      <el-breadcrumb-item v-for="(item,index) in navArr" :key="index" style="cursor: pointer">
        <span :id="[item.folderId === folderName1 ? 'active1' : '']" style="width:100%;display:block;text-align:center"
          class="ellipsis" :title="breadTitle(navArr,item)"
          @click="index !== (navArr.length - 1) && clickBread(item,index)">
          {{ item.folderName }}
        </span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      timeID: null
    };
  },
  computed: {
    ...mapState({
      navArr: state => state.perFile.navArrFen,
      currentNode: state => state.perFile.currentTreeNodeFen
    }),
    folderName1() {
      if (this.currentNode) {
        return this.currentNode.folderId;
      }
      return "";
    }
  },
  methods: {
    clickBread(item, index) {
      var arr = this.navArr.slice(0, index + 1);
      this.$store.dispatch("perFileUpdateTreeNodeFen", item);
      this.$store.dispatch("perFileUpdateNavFen", arr);
    },

    breadTitle(breadArr, item) {
      const titleArr = [];
      for (let i = 0; i < breadArr.length; i++) {
        titleArr.push(breadArr[i].folderName);
        if (breadArr[i].folderId === item.folderId) {
          break;
        }
      }
      return titleArr.join("/");
    },

    async returnUpOneLevel() {
      if (this.navArr.length > 1) {
        const length = this.navArr.length - 1;
        this.navArr.splice(length, 1);
        this.$store.dispatch("perFileUpdateNavDan", this.navArr);
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#navContainer {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
  box-sizing: border-box;
  padding: var(--middle-space) var(--big-space);

  .operations {
    display: flex;
    align-items: center;
    justify-content: space-around;

    img {
      cursor: pointer;
    }
    /deep/ .el-icon-return {
      background: url("../../../../../../CommonDP/assets/return.png") no-repeat;
      width: 14px;
      height: 12px;
    }
    /deep/ .el-icon-return:before {
      content: "替";
      font-size: 12px;
      visibility: hidden;
    }
  }

  /deep/ .el-breadcrumb::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  /deep/ .el-breadcrumb {
    white-space: nowrap;
    overflow-x: auto;
    display: flex;
    width: 65%;
    align-items: center;
    margin-left: var(--big-space);
    background-color: #fff;
    box-sizing: border-box;

    .el-breadcrumb__item {
      display: flex;
      padding: 3px 0;
    }

    .el-breadcrumb__separator {
      margin: 0;
      margin-right: 6px;
    }

    .el-breadcrumb__inner {
      display: block;
      max-width: 68px;

      span.ellipsis {
        color: var(--info-color);
      }

      span.ellipsis:hover {
        color: var(--theme-color);
      }

      span#active1 {
        color: var(--key-color);
      }
    }

    .el-icon-arrow-right {
      color: #000;
      margin: 0;
    }
  }
}
</style>
